import de from '~/root/static/locales/de.json';
import en from '~/root/static/locales/en.json';
import es from '~/root/static/locales/es.json';
import fr from '~/root/static/locales/fr.json';
import nl from '~/root/static/locales/nl.json';

export const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  nl: { translation: nl },
  de: { translation: de },
};
